export enum VENDOR_TYPES {
  MY_VENDORS = 'MY_VENDORS',
  COMMUNITY_VENDORS = 'COMMUNITY_VENDORS',
  TRENDING_VENDORS = 'TRENDING_VENDORS',
  RECOMMENDED_VENDORS = 'RECOMMENDED_VENDORS',
  OTHER_VENDORS = 'OTHER_VENDORS',
  CUSTOM_OPTION = 'CUSTOM_OPTION',
  VENDOR_LOUNGE = 'VENDOR_LOUNGE',
}

export const TabList = [
  {
    isActive: true,
    iconClass: 'fas fa-home',
    displayText: 'My Vendors',
    type: VENDOR_TYPES.MY_VENDORS,
    tabDescription: 'View a summary of your top vendors',
  },
  {
    isActive: false,
    iconClass: 'ri-community-line',
    displayText: 'Vendor Discovery',
    type: VENDOR_TYPES.COMMUNITY_VENDORS,
    tabDescription:
      'These are the most popular vendors across the Teleperson platform',
  },
  {
    isActive: false,
    iconClass: 'fas fa-store',
    displayText: 'Vendor Lounge',
    type: VENDOR_TYPES.VENDOR_LOUNGE,
    tabDescription: 'View a summary of vendor lounge',
  },
  // {
  //   isActive: false,
  //   iconClass: 'ri-fire-line',
  //   displayText: 'Trending Vendors',
  //   type: VENDOR_TYPES.TRENDING_VENDORS,
  //   tabDescription:
  //     'View vendors who have been receiving top scores and or are being added by others in your Teleperson community.',
  // },
  // {
  //   isActive: false,
  //   iconClass: 'ri-home-heart-fill',
  //   displayText: 'Recommended Vendors',
  //   type: VENDOR_TYPES.RECOMMENDED_VENDORS,
  //   tabDescription:
  //     'View recommended vendors based on your existing Vendors Hub or interest',
  // },
  // {
  //   isActive: false,
  //   iconClass: 'ri-home-smile-line',
  //   displayText: 'Other Vendors',
  //   type: VENDOR_TYPES.OTHER_VENDORS,
  //   tabDescription:
  //     ' View other vendors not included in trending or recommended',
  // },
];

export enum VENDOR_HUB_DROPDOWN_TYPES {
  VENDOR_LOUNGE = 'VENDOR_LOUNGE',
  LIST_VIEW = 'LIST_VIEW',
  FILTER = 'FILTER',
  SHARE = 'SHARE',
}

export const VendorHubDropDown = [
  // {
  //   iconClass: 'ri-home-gear-line',
  //   itemName: 'Vendor Lounge',
  //   type: VENDOR_HUB_DROPDOWN_TYPES.VENDOR_LOUNGE,
  //   isMuted: false,
  // },
  {
    iconClass: 'ri-list-ordered',
    itemName: 'List View',
    type: VENDOR_HUB_DROPDOWN_TYPES.LIST_VIEW,
    isMuted: true,
  },
  {
    iconClass: 'ri-filter-2-line',
    itemName: 'Filter',
    type: VENDOR_HUB_DROPDOWN_TYPES.FILTER,
    isMuted: true,
  },
  {
    iconClass: 'ri-stackshare-line',
    itemName: 'Share',
    type: VENDOR_HUB_DROPDOWN_TYPES.SHARE,
    isMuted: true,
  },
];

export const VendorSortOptions = [
  // {
  //   itemName: 'Most Recent',
  //   iconClass: 'mdi mdi-clock-time-eight-outline',
  //   type: 'recent',
  // },
  {
    itemName: 'Sort A-Z',
    iconClass: 'mdi mdi-sort-alphabetical-ascending',
    type: 'a-z',
  },
  {
    itemName: 'Sort Z-A',
    iconClass: 'mdi mdi-sort-alphabetical-descending',
    type: 'z-a',
  },
];
